// extracted by mini-css-extract-plugin
module.exports = {"SubstructureFilter":"SimilarityFilter_SubstructureFilter__3uQUf","Label":"SimilarityFilter_Label__2RyTo","RangeLabel":"SimilarityFilter_RangeLabel__1E4pt"};